import styled from '@emotion/styled';

const WorldInfo = styled('p')({
  margin: 0
});

export default WorldInfo;
